module.exports = __webpack_public_path__ + "img/Icon awesome-linkedin-in.dcabb5d6.svg";